module.exports = __webpack_public_path__ + "static/media/cementTruck_pink.80425b1f.svg";